import { render } from "./AddMonthlyCard.vue?vue&type=template&id=0fa3b331"
import script from "./AddMonthlyCard.vue?vue&type=script&lang=js"
export * from "./AddMonthlyCard.vue?vue&type=script&lang=js"

import "./AddMonthlyCard.vue?vue&type=style&index=0&id=0fa3b331&lang=scss"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__